import { GridColDef } from '@mui/x-data-grid';
import { Button } from '@mui/material';
import { AdSpaceCouponCodeInterface } from '../../../interfaces/interfaces';

export const getAdSpaceCouponCodesColumns = (
  setCodeToDelete: (code: AdSpaceCouponCodeInterface) => void,
  setDeleteDialogOpen: (open: boolean) => void,
  setCodeToUpdate: (code: AdSpaceCouponCodeInterface) => void,
  setUpdateDialogOpen: (open: boolean) => void
): GridColDef[] => [
  { field: 'id', headerName: 'ID', width: 70 },
  { field: 'adSpaceId', headerName: 'AdSpace ID', width: 100 },
  { 
    field: 'adSpaceName', 
    headerName: 'AdSpace Name', 
    width: 250,
    valueGetter: (value, row) => row.adSpace?.geoName || '-'
  },
  { field: 'code', headerName: 'Code', width: 130 },
  { field: 'discountType', headerName: 'Type', width: 120 },
  { field: 'discountValue', headerName: 'Value', width: 90 },
  { 
    field: 'usage', 
    headerName: 'Usage', 
    width: 100,
    valueGetter: (value, row) => `${row.currentUses || 0} / ${row.maxUses || '∞'}`
  },
  { 
    field: 'validFrom', 
    headerName: 'Valid From', 
    width: 110,
    valueGetter: (value, row) => row.validFrom ? new Date(row.validFrom).toLocaleDateString() : '-'
  },
  { 
    field: 'validUntil', 
    headerName: 'Valid Until', 
    width: 110,
    valueGetter: (value, row) => row.validUntil ? new Date(row.validUntil).toLocaleDateString() : '-'
  },
  { field: 'active', headerName: 'Active', width: 90, type: 'boolean' },
  { field: 'combinableWithOthers', headerName: 'Combinable', width: 110, type: 'boolean' },
  {
    field: 'delete',
    headerName: 'Delete',
    width: 100,
    renderCell: (params) => (
      <Button
        color="error"
        variant="outlined"
        size="small"
        onClick={() => {
          setCodeToDelete(params.row);
          setDeleteDialogOpen(true);
        }}
      >
        Delete
      </Button>
    ),
    sortable: false,
    filterable: false,
  },
  {
    field: 'update',
    headerName: 'Update',
    width: 100,
    renderCell: (params) => (
      <Button
        color="primary"
        variant="outlined"
        size="small"
        onClick={() => {
          setCodeToUpdate(params.row);
          setUpdateDialogOpen(true);
        }}
      >
        Update
      </Button>
    ),
    sortable: false,
    filterable: false,
  },
];
